import { render } from "./PopupList.vue?vue&type=template&id=40446e75&scoped=true"
import script from "./PopupList.vue?vue&type=script&lang=js"
export * from "./PopupList.vue?vue&type=script&lang=js"

import "./PopupList.vue?vue&type=style&index=0&id=40446e75&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40446e75"],['__file',"src/assets/js/components/Form/PopupList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40446e75"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40446e75', __exports__)) {
    api.reload('40446e75', __exports__)
  }
  
  module.hot.accept("./PopupList.vue?vue&type=template&id=40446e75&scoped=true", () => {
    api.rerender('40446e75', render)
  })

}


export default __exports__